/* ============
 * License Group Transformer
 * ============
 *
 * The transformer for the licensePermitGroup.
 */

import Transformer from './transformer';

export default class licensePermitGroupTransformer extends Transformer {

  static fetch(licensePermitGroup) {
    return {
      id: licensePermitGroup.id,
      licensePermitId: licensePermitGroup.license_permit_id,
      licenseGroupId: licensePermitGroup.license_group_id,
      licenseGroup: licensePermitGroup.license_group,
    };
  }

  static send(licensePermitGroup) {
    return {
      id: licensePermitGroup.id,
      license_permit_id: licensePermitGroup.licensePermitId,
      license_group_id: licensePermitGroup.licenseGroupId,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/licensePermitGroup.js